import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ConfigContext from '../../../contexts/ConfigContext';

import sidebarStyles from '../../../../stylesheets/public/layouts/SidebarLayout.module.postcss';
import styles from './TruckSidebar.module.postcss';

function TruckSidebar({ truckName }) {
  const { city_name, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  return (
    <div className={sidebarStyles.Sidebar}>
      <div className={sidebarStyles.Sidebar_item}>
        <div className={sidebarStyles.Sidebar_header}>
          <h3 className='u-phosphate u-mb0'>Book This Food {vehicle_type}</h3>
        </div>
        <div className={sidebarStyles.Sidebar_padding}>
          <p>Tell us about your event to get a quote from {truckName} and access to over 500 of {city_name}&#39;s best food {vehicleType}s!</p>

          <Link to='/catering/register' className='Button u-mb1 u-w100'>
            Book {truckName || `a food ${vehicleType}`}
          </Link>

          <p className='u-textCenter'>It only takes 2 minutes!</p>
        </div>
      </div>

      <div className={sidebarStyles.Sidebar_item + ' ' + sidebarStyles.Sidebar_padding}>
        <h3 className='u-phosphate u-mb1'>Why book with us?</h3>
        <div className={styles.TruckSidebar_list}>
          <div>
            <div><span className='icon icon-approved' /></div>
            <div>Free, no-obligation quotes tailored to your event</div>
          </div>
          <div>
            <div><span className='icon icon-approved' /></div>
            <div>Access to hundreds of top food {vehicleType}s in your area</div>
          </div>
          <div>
            <div><span className='icon icon-approved' /></div>
            <div>Effortless way to make your event unique and memorable</div>
          </div>
        </div>
      </div>
    </div>
  );
}

TruckSidebar.propTypes = {
  truckName: PropTypes.string,
};

export default TruckSidebar;
